<template>
  <div class="pageDiv">
    <v-card class="no-login" v-if="!$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Handicap Admin</span>
      </v-card-title>

      Must login to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Handicap Admin ({{displayMembers.length}})</span>
      </v-card-title>
      <v-card>
        <div class="action-card">
            <btn :class="{actionBusy: running}" class="primary-btn action-buttons" @click="assignCourse()">Assign Course</btn>
            <btn :class="{actionBusy: running}" class="primary-btn action-buttons" @click="calculateHandicap()">Calc HCP</btn>
            <btn :class="{actionBusy: running}" class="primary-btn action-buttons" @click="calculatePlayersHandicap()">Calc Players HCP</btn>
            <btn :class="{actionBusy: running}" class="primary-btn action-buttons" @click="saveAll()">Save All</btn>
        </div>
        <v-card-text>
          <input type="checkbox" style="width:20px;height:20px" @click="showMembers=!showMembers;filter()"> Members Only
          <input type="checkbox" style="width:20px;height:20px;margin-left: 15px;" @click="excludeZero=!excludeZero;filter()"> Exclude Zeros

        </v-card-text>
      </v-card>

      <v-card class="p-card">
        <v-card-text class="">
          <v-simple-table class="simple-table">
            <tr>
              <th width="10px">#</th>
              <th></th>
              <th>Name</th>
              <th>Flight</th>
              <th>Rnds</th>
              <th width="10px">
                <a class="sortLink" @click="sort('hcp')">HCP</a>
              </th>
              <th>
                <a class="sortLink" @click="sort('dfwvga')">CALC HCP</a>
              </th>
              <th width="10px">
                <a class="sortLink" @click="sort('diff')">DIFF</a>
              </th>
            </tr>
            <tr  v-for="(player, index) in displayMembers" :key="player">
              <td  :class="{changedData: player.isChanged}" >{{index+1}}</td>
              <td>
                <button @click="save(player.player)" class="primary-btn" style="padding:2px;">
                  <span class="lbl10">Save</span>
                </button>
              </td>
              <td>{{player.player.firstName}} {{player.player.middleName}} {{player.player.lastName}}
                <v-img class="member-logo" v-if="player.membership" src="../../assets/img/dfwvga-logo-mini.png">
                </v-img>
              </td>
              <td>
                <select class="dropdown" v-model="player.player.defaultFlight" @change="player.isChanged=true">
                  <option value="Nicklaus">Nicklaus</option>
                  <option value="Palmer">Palmer</option>
                  <option value="Hogan">Hogan</option>
                </select>
              </td>
              <td>{{player.player.hcpRounds}}</td>
              <td>
                <input class="dfwvga-btn" style="width:60px" v-model="player.player.handicap"
                       @change="player.isChanged=true" @keypress="player.isChanged=true"/>
              </td>
              <td>{{getScoreHcp(player.player.dfwvgaHandicap)}}</td>
              <td>{{getScoreHcp(player.player.diff)}}</td>
            </tr>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      memberPlayers: [],
      displayMembers: [],
      showMembers: false,
      excludeZero: false,
      running: false
    }),
    mounted: function() {
      this.loadPlayers();
    },
    methods: {
      loadPlayers() {
        var _this = this;

        this.axios.get('/admin/players')
        .then(function (response) {
            _this.memberPlayers = response.data;
            for(var i=0; i < _this.memberPlayers.length; i++) {
              if (_this.memberPlayers[i].player.handicap !== null &&
                  _this.memberPlayers[i].player.handicap !== '' &&
                  _this.memberPlayers[i].player.handicap !== '0') {
                _this.memberPlayers[i].player.diff =
                    _this.memberPlayers[i].player.dfwvgaHandicap - _this.memberPlayers[i].player.handicap;
              } else {
                _this.memberPlayers[i].player.diff = '';
              }
              _this.memberPlayers[i].player.isChanged = false;
            }
            _this.displayMembers = _this.memberPlayers
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);
        });
      },
      getScoreHcp(scoreHcp) {
        if (scoreHcp === '' || scoreHcp > 60.00) {
          return "";
        }
        else {
          return Number(scoreHcp).toFixed(2);
        }
      },
      sort(field) {
        if (field === 'hcp') {
            this.displayMembers.sort((a, b) => ( a.player.handicap > b.player.handicap ) ? 1 : -1);
            this.pushDNPBottom();
        }
        else if (field === 'dfwvga') {
            this.displayMembers.sort((a, b) => ( a.player.dfwvgaHandicap > b.player.dfwvgaHandicap ) ? 1 : -1);
        }
        else if (field === 'diff') {
            this.displayMembers.sort((a, b) => ( a.player.diff > b.player.diff ) ? 1 : -1);
        }
      },
      assignCourse() {
        var _this = this;
        if ( !_this.running ) {
          _this.running = true;
          this.axios.get('/admin/scores/assign-course')
          .then(function (response) {
            console.log("COMPLETE Successfully " + response.data);
            _this.running = false;
            swal("Success", "Assign course completed successfully.", "info");
          })
          .catch(function (error) {
            console.log('ERROR: ' + error);
            _this.running = false;
            swal("Error", "Assign course failed.", "error");
          });
        }
      },
      calculateHandicap() {
        var _this = this;
        if ( !_this.running ) {
          _this.running = true;
          this.axios.get('/admin/scores/calculate-handicap')
          .then(function (response) {
            console.log("COMPLETE Successfully " + response.data);
            _this.running = false;
            swal("Success", "Calculate score handicap completed successfully.", "info");
          })
          .catch(function (error) {
            console.log('ERROR: ' + error);
            _this.running = false;
            swal("Error", "Calculate score handicap failed.", "error");
          });
        }
      },
      calculatePlayersHandicap() {
        var _this = this;
        if ( !_this.running ) {
          _this.running = true;
          this.axios.get('/admin/scores/calculate-players-handicap')
          .then(function (response) {
            console.log("COMPLETE Successfully " + response.data);
            _this.running = false;
            swal("Success", "Calculate players handicap completed successfully.", "info");
          })
          .catch(function (error) {
            console.log('ERROR: ' + error);
            _this.running = false;
            swal("Error", "Calculate players handicapÏ failed.", "error");
          });
        }
      },
      filter() {
        this.displayMembers = new Array();
        for (var i=0; i < this.memberPlayers.length; i++) {
          if ( this.showMembers && !this.memberPlayers[i].membership ) {
            continue;
          }
          var p = this.memberPlayers[i].player;
          if ( this.excludeZero && (p.handicap === 0 && p.dfwvgaHandicap===0) ) {
            continue;
          }

          this.displayMembers.push(this.memberPlayers[i]);
        }
      },
      saveAll() {
        var _this = this;
        if ( !_this.running ) {
          _this.running = true;
          var i;
          for(i=0; i < _this.displayMembers.length; i++) {
            if (_this.displayMembers[i].isChanged) {
              console.log('UPDATING... ' + _this.displayMembers[i].player.firstName);
              _this.save(_this.displayMembers[i].player);
            }
          }
          _this.running = false;
        }
      },
      async save(player) {
          console.log("Save handicap");
          var request = {
            flight: player.defaultFlight,
            handicap: player.handicap
          };

          await this.axios.post('/admin/players/' + player.playerId+ '/update-handicap', request)
          .then(function (response) {
              swal("Success", "Save handicap successfully.", "info")
          })
          .catch(function (error) {
              console.log('ERROR: ' + error);
          });
      }
    }
  }

</script>

<style scoped>

  .member-logo {
    display: inline-block;
    height: 20px;
    width: 20px;
    border-radius: 45px;
    margin-left: 10px;
  }

  .primary-btn {
    border-radius: 5px;
  }

  .sortLink {
    color: yellow;
  }

  .action-card {
      display: inline-block;
      height: 60px;
      width: 100%;
      padding: 7px;
  }

  .action-buttons {
      display: inline-block;
      margin: 7px;
      padding: 8px;
      border: 2px solid black;
      border-radius: 7px;
  }

  .actionBusy {
     background-color: lightgrey !important;
     color: darkgray !important;
     cursor: wait;
     border: 2px solid darkgray !important;
  }

  .changedData {
    background-color: lightgray;
  }

  @media (min-width: 768px) {
    .action-buttons {
        margin-right: 10px;
        float: left;
    }
  }

</style>